export class ShippingMethod {


    amount: number
    available: boolean
    base_amount: number
    carrier_code: string
    carrier_title: string
    error_message: string
    method_code: string = "-1"
    method_title: string
    priceExclTax: number
    priceInclTax: number

}